module.exports = __webpack_public_path__ + "img/IT0001863196870.21d4644e.png";